// src/theme/palette.js
export const palette = {
    mode: 'dark',
    primary: {
      main: '#0288d1',
      light: '#03a9f4',
      dark: '#01579b'
    },
    secondary: {
      main: '#00bcd4',
      light: '#26c6da',
      dark: '#00838f'
    },
    background: {
      default: '#0a1929',
      paper: '#111927'
    }
  };
  